module.exports = __webpack_public_path__ + "img/skilllist_2.e03ce2c9.png";